<template>
    <div class="card-body">
        <div class="text-center mb-3">
            <i class="icon-user-lock icon-2x text-slate-300 border-slate-300 border-3 rounded-round p-3 mb-3 mt-1"></i>
            <h5 class="mb-0">{{ $t('auth.authentication.forgot_password_title') }}</h5>
            <span class="d-block text-muted">{{ $t('auth.authentication.forgot_password_description') }}</span>
        </div>

        <form @submit.prevent="sendCode">
            <FormGroup :label="$t('auth.fields.email')">
                <Input type="text" :placeholder="$t('auth.fields.email')" v-model="email"/>
            </FormGroup>

            <div class="btn-group-justified">
                <Button size="sm" type="submit" color="primary">{{ $t('auth.buttons.send') }}<i class="icon-circle-right2 ml-2"></i></Button>
            </div>
        </form>
    </div>
</template>

<script>
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import Button from "../../../../../components/new/button/AppButton.vue";
import { httpClient } from "../../../../../services/HttpClient";

export default {
    name: "ForgotPasswordCard",
    components: {
        FormGroup,
        Input,
        Button,
    },
    emits: ['code-sent'],
    data() {
        return {
            email: null,
        }
    },
    methods: {
        async sendCode() {
            await httpClient.post('/authentication/forget', {
                email: this.email,
            });

            this.$emit('code-sent', this.email);
        },
    },
}
</script>
